// REMARKS:
// Variables and functions are stored in subscription-form-common.js
// settingsJson should be defined in the liquid section

document.addEventListener("alpine:init", function () {
  Alpine.data("starEmailSubscriptionForm", () => ({
    loading: false,
    checked: false,
    contact_email: "",
    isSuccess: false,
    errMsg: "",

    async postEcoflowSubscribeApiAndSubmitForm() {
      const email = this.contact_email;
      this.errMsg = "";
      this.isSuccess = false;

      const isEmailValid = validateEmail(email);
      if (!isEmailValid) {
        this.errMsg = "Please enter a valid email address";
        return;
      }

      // createFieldsArray and getContactListId function in subscription-form-common.js
      const fieldsArray = createFieldsArray(starSettingJsons);
      const contactListId = getContactListId(starSettingJsons);

      const subscribeInfoCookie = window.getCookieForEmarsys('subscribe_info');
      let eventTracking = null;

      if (subscribeInfoCookie) {
        try {
          const decodedCookie = decodeURIComponent(subscribeInfoCookie)
          eventTracking = JSON.parse(decodedCookie);
          delete eventTracking.ts
          console.log('eventTracking', eventTracking);
        } catch (error) {
          console.log('eventTracking error', subscribeInfoCookie);
          console.warn('Failed to parse subscribe_info cookie:', error);
        }
      };

      // Extract theme global variables from theme.liquid
      const { apiUrl, acceptedLanguage, apiKey, xAppid } =
        theme.emailSubscription;

      const apiBody = {
        email,
        contactListId,
        fields: fieldsArray,
        ...(eventTracking && { eventTracking }),
      };
      try {
        this.loading = true;
        const response = await fetch(
          // Header global settings are defined in star-email-subscription-form.liquid
          // Except traceId is defined in subscription-form-common.js
          apiUrl,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              apiKey: apiKey,
              traceId: traceId,
              "X-appid": xAppid,
              "Accepted-Language": acceptedLanguage,
            },
            body: JSON.stringify(apiBody),
          }
        );

        const data = await response.json();

        if (data.message === "Success") {
          this.isSuccess = true;
          this.errMsg = "";
        } else {
          this.errMsg =
            "Oops... Something went wrong, please refresh and try again.";
          console.log(data.message);
        }
      } catch (error) {
        this.errMsg =
          "Oops... Something went wrong, please refresh and try again.";
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  }));
});